import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/rili.png'
import _imports_1 from '@/assets/images/match_tab_next.png'


const _withScopeId = n => (_pushScopeId("data-v-1c7a8099"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = { class: "oppen-rl" }
const _hoisted_3 = { class: "showtitle" }
const _hoisted_4 = { class: "subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_tabs, {
      onChange: $setup.tabchange,
      sticky: "",
      "offset-top": $setup.props.offset_top,
      active: $setup.state,
      "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => (($setup.state) = $event)),
      background: "#F8F8F8",
      "title-active-color": "#303030",
      "title-inactive-color": "#898989",
      "line-width": "30px",
      color: $setup.primaryColor
    }, {
      "nav-right": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {$setup.show = true;})
          })
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.classList, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_tab, null, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(item.short_name_zh), 1 /* TEXT */)
            ]),
            default: _withCtx(() => [
              _createVNode($setup["MatchList"], {
                competition_id: item.competition_id,
                nav_type: $setup.props.nav_type,
                match_type: item.match_type,
                index: index,
                name: item.short_name_zh
              }, null, 8 /* PROPS */, ["competition_id", "nav_type", "match_type", "index", "name"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["offset-top", "active", "color"]),
    _createVNode(_component_van_calendar, {
      title: $setup.t('match.mathDay'),
      show: $setup.show,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (($setup.show) = $event)),
      onConfirm: $setup.onConfirm,
      "safe-area-inset-top": "",
      "min-date": $setup.minDate,
      "max-date": $setup.maxDate,
      formatter: $setup.formatter,
      position: "top",
      "show-confirm": false
    }, {
      subtitle: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "subtitle_next",
            src: _imports_1,
            onClick: $setup.subtitleLeft
          }),
          _createElementVNode("div", null, _toDisplayString($setup.minDate.getFullYear()) + " - " + _toDisplayString($setup.minDate.getMonth() + 1), 1 /* TEXT */),
          _createElementVNode("img", {
            class: "subtitle_next subtitle_next_right",
            src: _imports_1,
            onClick: $setup.subtitleRight
          })
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title", "show", "min-date", "max-date"])
  ]))
}